import React from "react";
import "./promoPage.scss";

import Footer from "./../../components/footer/Footer";
import emailjs from 'emailjs-com';



const icons = {
    abc: require('./../../assets/network/abc.png'),
    cbs: require('./../../assets/network/cbs.png'),
    fox: require('./../../assets/network/fox.png'),
    tvj: require('./../../assets/network/tvj.png'),
    cvm: require('./../../assets/network/cvm.png'),
    msnbc: require('./../../assets/network/msnbc.png'),
    nbc: require('./../../assets/network/nbc.png'),
}

const getIconUrl = (name) => {
    return icons[name].default;
}

class PromoPage extends React.Component {

    
    constructor (props) {
        super(props);
        this.state = {
            error: false,
            message: false
        }

        this.sendEmail = this.sendEmail.bind(this);
    }

    sendEmail(evt) {
        evt.preventDefault();
        const form  = evt.target;

        let formPayload = {};
        Object.keys(form.elements).forEach(key => {
            let element = form.elements[key];
            if (element.type !== "submit") {
                formPayload[element.name] = element.value;
            }
        });


        /*
        const message = {
            text: 'i hope this works',
            from: 'Virtual Enterprise.LTD <sales@myvirtualoffices.com>',
            to: 'Ricardo Walford <ricardo.walford@gmail.com>',
            cc: 'else <patrick231274@gmail.com>',
            subject: 'testing emailjs',
            attachment: [
                { data: '<html>i <i>hope</i> this works!</html>', alternative: true },
            ],
        };

        const client = new SMTPClient({
            user: '_mainaccount@axlejm.com',
            password: 'Lonneke2312',
            host: 'mail.axlejm.com',
            //ssl: true,
            tls: {
                ciphers: 'SSLv3'
            }
        });
       
    
        
        // send the message and get a callback with an error or details of the message that was sent
        client.send(message, function (err, message) {
            console.log(err || message);
        });
        
        */

        emailjs.sendForm('service_bvh96hl', 'template_xcqpl1s', evt.target, 'user_nifZ8oMdkynL2jVhCl9Tj')
        .then((result) => {
            result.status === 200 && this.setState({message: result.text });
            evt.target.reset();
        }, (error) => {
            console.log(error);
            error && this.setState({error: error})
        });
        
    }

    render () {

        return <React.Fragment>
            <div className="main-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col col-md-8">
                             <div className="sec">
                                    <h1 className="main-title">Wow your callers <br/>with our live receptionists<br /> Try us for FREE!</h1>
                             </div>
                             <div className="sec">
                                <article className="article">
                                    <p className="sub-title">
                                        No credit cards, no contracts!, With Virtual Enterprise
                                        Answering Service you receive 1 week of service with all 
                                        the features of a paying customer. No Gimicks, No Tricks!
                                    </p>
                                </article>
                             </div>
                             <div className="sec">
                                    <p className="featured-label">Featured on:</p>
                                    <ul className="feature-list">
                                        <li className="item">
                                            <span><img src={getIconUrl('abc')}/></span>
                                        </li>
                                        <li className="item">
                                            <span><img src={getIconUrl('cbs')}/></span>
                                        </li>
                                        <li className="item">
                                            <span><img src={getIconUrl('fox')}/></span>
                                        </li>
                                        <li className="item">
                                            <span><img src={getIconUrl('tvj')}/></span>
                                        </li>
                                        <li className="item">
                                            <span><img src={getIconUrl('cvm')}/></span>
                                        </li>
                                        <li className="item">
                                            <span><img src={getIconUrl('msnbc')}/></span>
                                        </li>
                                        <li className="item">
                                            <span><img src={getIconUrl('nbc')}/></span>
                                        </li>
                                    </ul>
                             </div>
                        </div>
                        <div className="col col-md-4">
                            <div className="signup-form">
                                <div className="form-content">
                                    <form className="form" onSubmit={this.sendEmail}>
                                        <h1>Start your free trial now!</h1>
                                        <p>No creadi card required. 100% free to get started 1 week free trial.</p>

                                        {this.state.message && (
                                            <div className={[this.state.error ? 'error_message' : 'success_message', 'message'].join(' ')}>
                                                {this.state.error
                                                ? 'There' + ' was an' + ' error submitting your message.'
                                                : 'Message recieved. Have a great day!'}
                                            </div>
                                            )
                                        }
                                        <div className="form-group input-fields">
                                            <input 
                                            name="firstName"
                                            type="text" 
                                            placeholder="First Name"
                                            required />
                                            <input 
                                            type="text" 
                                            name="lastName"
                                            placeholder="Last Name"
                                            required/>
                                        </div>
                                        <div className="form-group input-field">
                                            <input 
                                            name="email"
                                            type="email" placeholder="example@mail.com" 
                                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                                            required />
                                        </div>
                                        <div className="form-group input-field">
                                            <input 
                                            name="company"
                                            type="text" 
                                            required
                                            placeholder="Company"/>
                                        </div>
                                        <div className="form-group input-field">
                                            <input 
                                            name="phone"
                                            required 
                                            type="text" placeholder="888-888-8888" />
                                        </div>
                                        <div className="form-group input-field">
                                            <select 
                                             name="country"
                                             className="service-opt"
                                             required>
                                                <option>Location of Service</option>
                                                <option>Jamaica</option>
                                                <option>USA</option>
                                                <option>Canada</option>
                                            </select>
                                        </div>
                                        <div className="form-group input-field">
                                            <button type="submit" className="submit-btn" >Sign up for free</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment> 
    }
}

export default PromoPage;